import { CircularProgress } from '@components/core-ui/spinners/CircularProgress';
import styled from 'styled-components';

export const StyledCircularProgress = styled(CircularProgress).attrs({
  rotate: -90,
})`
  position: relative;
`;
